export const environment = {
  production: true,
  api: {
    baseUrl: '//walle.staging.livee.com/api'
  },
  translations: {
    baseUrl: '//translations.livee.com/api'
  }
};



// WEBPACK FOOTER //
// /www/sms-simulator/sms-front/src/environments/environment.ts